import { useEffect } from 'react';
import { DocumentViewer as SADocumentViewer } from 'react-documents';

const DocumentViewer = (props) => {

    useEffect(() => {
    }, [props]);

    return (
        <>
            {props?.myContent &&
                <SADocumentViewer
                    className="sa-docviewer w-100 p-3"
                    style={{ height: `${props?.height}px` }}
                    url={props?.myContent} />}
        </>
    )
}

export default DocumentViewer;